export default __webpack_public_path__ + "static/media/meeting.3f134db8.png";